import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { EditActions, editActions } from "../../actions/editActions";
import { pdApiActions } from "../../actions/pdApiActions";
import { Button, Checkbox, Dropdown, Icon } from "semantic-ui-react";
import SideView from "../../components/Editing/SideView";

enum AppExportLanguages {
  "C" = 1,
  "CPP" = 2,
  "DOTNET" = 4,
  "PYTHON" = 8,
  "LUA" = 16,
  "CPP11" = 32
}
type StateProps = {
  developmentPackage: Api.DevelopmentPackage;
  pdApi: State.PdApi;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {
  toggleModal: () => void;
};

type EditDevelopmentPackageState = {
  C?: boolean;
  CPP?: boolean;
  DOTNET?: boolean;
  PYTHON?: boolean;
  LUA?: boolean;
  CPP11?: boolean;
  is250Floor?: boolean;
};

export type EditDevelopmentPackageProps = StateProps & DispatchProps & OwnProps;

export class EditDevelopmentPackage extends React.Component<
  EditDevelopmentPackageProps,
  EditDevelopmentPackageState
> {
  state = {
    C: true,
    CPP: true,
    DOTNET: true,
    PYTHON: true,
    LUA: true,
    CPP11: true,
    is250Floor: false
  };

  calculateBitmask = (): number => {
    const languagesBitmask =
      (this.state.C ? AppExportLanguages.C : 0) |
      (this.state.CPP ? AppExportLanguages.CPP : 0) |
      (this.state.CPP11 ? AppExportLanguages.CPP11 : 0) |
      (this.state.DOTNET ? AppExportLanguages.DOTNET : 0) |
      (this.state.LUA ? AppExportLanguages.LUA : 0) |
      (this.state.PYTHON ? AppExportLanguages.PYTHON : 0);
    return languagesBitmask;
  };

  render(): JSX.Element {
    const { C, CPP, DOTNET, PYTHON, LUA, CPP11, is250Floor } = this.state;

    const dropdownOptions = [
      { key: "150-floor", text: "150 Floor (For C-SW)", value: false },
      { key: "250-floor", text: "250 Floor", value: true }
    ];

    return (
      <SideView
        itemName={"Select languages"}
        hasWritePermission={true}
        isValid={true}
        cancel={this.props.editActions.cancelEditing}
      >
        <h3>Select programming languages to export</h3>
        <div className="sideview-checkbox-property">
          <Checkbox
            id="c"
            label="C"
            name="C"
            checked={C}
            onChange={(e, v) => {
              this.setState({ C: v.checked });
            }}
          />
        </div>
        <div className="sideview-checkbox-property">
          <Checkbox
            id="cpp"
            label="C++"
            name="CPP"
            checked={CPP}
            onChange={(e, v) => {
              this.setState({ CPP: v.checked });
            }}
          />
        </div>
        <div className="sideview-checkbox-property">
          <Checkbox
            id="csharp"
            label="C#.NET"
            name="DOTNET"
            checked={DOTNET}
            onChange={(e, v) => {
              this.setState({ DOTNET: v.checked });
            }}
          />
        </div>
        <div className="sideview-checkbox-property">
          <Checkbox
            id="python"
            label="Python"
            name="PYTHON"
            checked={PYTHON}
            onChange={(e, v) => {
              this.setState({ PYTHON: v.checked });
            }}
          />
        </div>
        <div className="sideview-checkbox-property">
          <Checkbox
            id="lua"
            label="LUA"
            name="LUA"
            checked={LUA}
            onChange={(e, v) => {
              this.setState({ LUA: v.checked });
            }}
          />
        </div>
        <div className="sideview-checkbox-property">
          <Checkbox
            id="cpp11"
            label="CPP11"
            name="CPP11"
            checked={CPP11}
            onChange={(e, v) => {
              this.setState({ CPP11: v.checked });
            }}
          />
        </div>

        <Button.Group>
          <Dropdown
            className="button icon"
            size={"big"}
            floating
            trigger={<></>}
            style={{ minWidth: "0", padding: "15", backgroundColor: "#0071b9", color: "#ffffff" }}
          >
            <Dropdown.Menu>
              {dropdownOptions.map(option => (
                <Dropdown.Item
                  key={option.key}
                  text={option.text}
                  onClick={() => this.setState({ is250Floor: option.value })}
                  active={is250Floor === option.value}
                  icon={is250Floor === option.value ? <Icon name="check" style={{ color: "#0071b9" }} /> : null}
                />
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Button
            id="CreatePackage"
            size={"big"}
            className="sideview-button-package-property"
            fluid={true}
            onClick={() => {
              const DevelopmentPackageOpts: Api.DevelopmentPackage = {
                id: this.props.developmentPackage.id,
                languagesBitmask: this.calculateBitmask(),
                typeDDMemory: is250Floor
              };
              this.props.pdApiActions.exportDevelopmentPackage(DevelopmentPackageOpts);
              this.props.editActions.cancelEditing();
            }}
            style={{ width: "230%" }}
          >
            Create package
          </Button>
        </Button.Group>
      </SideView>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  developmentPackage: state.editView.storedObject,
  pdApi: state.pdApi,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDevelopmentPackage);
